import { SvgIcon } from '@material-ui/core'

export default function LeftArrowIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                transform="translate(5.5 7)"
                d="M5.28033 1.53033C5.57322 1.23744 5.57322 0.762563 5.28033 0.46967C4.98744 0.176777 4.51256 0.176777 4.21967 0.46967L0.21967 4.46967C-0.0732231 4.76256 -0.0732231 5.23744 0.21967 5.53033L4.21967 9.53033C4.51256 9.82322 4.98744 9.82322 5.28033 9.53033C5.57322 9.23744 5.57322 8.76256 5.28033 8.46967L2.56066 5.75H12.25C12.6642 5.75 13 5.41421 13 5C13 4.58579 12.6642 4.25 12.25 4.25H2.56066L5.28033 1.53033Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
